module.exports = __webpack_public_path__ + "img/l.eb89fe2e.jpg";